var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notice-container"},[_vm._v("官网公告")])
}
var staticRenderFns = []

export { render, staticRenderFns }